const empData = (function () {
    let widget;
    let widgetBody;
    let tableElement;
    let filterPopup;

    // UI elements
    let categoryDropdown;
    let sortByDropdown;
    let expirationInput;
    let applyFiltersBtn;
    let cancelFilterBtn;

    let sortData = [];
    let categories = [];

    // Filter values    
    let selectedCategory;
    let selectedSortBy;
    let selectedExpiration;

    function popFromEmployeeEmail(entryData) {
        const oldEmailPopup = document.getElementById('employeeEmailPopup');
        if (oldEmailPopup) POPUP.hide(oldEmailPopup);

        const oldPopup = document.getElementById('employeeEmailSelectorPopup');
        if (oldPopup) oldPopup.remove();

        const emailSelectorPopup = dashboard.buildemailSelectorPopup();
        emailSelectorPopup.id = 'employeeEmailSelectorPopup';
        emailSelectorPopup.style.position = 'fixed';
        emailSelectorPopup.style.top = '50%';
        emailSelectorPopup.style.left = '50%';
        emailSelectorPopup.style.transform = 'translate(-50%, -50%)';
        emailSelectorPopup.style.zIndex = '10000';
        emailSelectorPopup.style.display = 'block';
        emailSelectorPopup.style.visibility = 'visible';
        emailSelectorPopup.style.opacity = '1';

        document.body.appendChild(emailSelectorPopup);

        const emailToDropdown = dropdown.build({
            label: 'Email To',
            dropdownId: 'emailToDropdown',
            style: 'secondary',
            readonly: false
        });

        emailSelectorPopup.appendChild(emailToDropdown); 
        empDataAjax.getEmployeeToEmailAsync().then(response => {
            const employeeEmailResults = response || [];
            const emailDropdownData = employeeEmailResults.map(val => ({
                id: val.personID,
                value: val.emailTo,
                text: val.fullName
            }));
            const selected = emailDropdownData[0]?.value;
            dropdown.populate('emailToDropdown', emailDropdownData, selected);
        });

       const applyBtn = button.build({
            text: 'Apply',
            style: 'secondary',
            type: 'contained',
            callback: () => {
                const dropdownElem = document.getElementById('emailToDropdown');
                if (!dropdownElem) return;

                const selectedEmail = dropdownElem.value;

                // Hide the selector popup first
                POPUP.hide(emailSelectorPopup);

                // Show the original email popup
                const originalEmailPopup = document.getElementById('employeeEmailPopup');
                if (originalEmailPopup) {
                    POPUP.show(originalEmailPopup);

                    // Set value in the email input field
                    const toInputElem = document.getElementById('emailToInput');
                    if (toInputElem && selectedEmail !== '%' && selectedEmail !== '') {
                        toInputElem.value = selectedEmail;
                        toInputElem.dispatchEvent(new Event('input'));
                    }
                } else {
                    // If popup doesn't exist, recreate it with the selected email
                    showEmployeeEmailPopup(entryData, selectedEmail);
                }
            }
       });

       const cancelBtn = button.build({
            text: 'Cancel',
            style: 'secondary',
            type: 'outlined',
            callback: () => {
                POPUP.hide(emailSelectorPopup);
                showEmployeeEmailPopup(entryData);
            }
       });

       const btnWrap = document.createElement('div');
       btnWrap.classList.add('btnWrap');
       btnWrap.appendChild(applyBtn);
       btnWrap.appendChild(cancelBtn);

       emailSelectorPopup.appendChild(btnWrap);

       POPUP.show(emailSelectorPopup);
    }
    function showEmployeeEmailPopup(entryData, preSelectedEmail = '') {       
        let bodyContent = entryData.expirationDate;
        const old = document.getElementById('employeeEmailPopup');
        if (old) old.remove();

        const emailPopup = dashboard.buildEmailPopup();
        emailPopup.id = 'employeeEmailPopup';
        emailPopup.style.position = 'fixed';
        emailPopup.style.top = '50%';
        emailPopup.style.left = '50%';
        emailPopup.style.transform = 'translate(-50%, -50%)';
        emailPopup.style.zIndex = '10000';
        emailPopup.style.display = 'block';
        emailPopup.style.visibility = 'visible';
        emailPopup.style.opacity = '1';

        const heading = document.createElement('h3');
        heading.style.marginBottom = '15px';
        heading.textContent = 'Employee Data Update Request';
        const selectEmployeeBtn = button.build({
            text: 'SELECT EMPLOYEE',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                popFromEmployeeEmail(entryData);
            },
        });
        selectEmployeeBtn.style.width = '100%';
        const toInput = input.build({
            label: 'Email To Addresses:',
            callbackType: 'input',
            id: 'emailToInput',
            value: preSelectedEmail,           
        });
        const ccInput = input.build({
            label: 'Email Cc Addresses:',
            callbackType: 'input',
            id: 'emailCcInput'
        });
        const bccInput = input.build({
            label: 'Email Bcc Addresses:',
            callbackType: 'input',
            id: 'emailBccInput'
        });
        const subjectInput = input.build({
            label: 'Email Subject:',
            callbackType: 'input',
            id: 'emailSubjectInput',
            value: `${entryData.category} - ${entryData.subCategory}`,
        });
        const bodyInput = input.build({
            label: 'Email Body:',
            type: 'textarea',
            classNames: 'autosize',
            callbackType: 'input',
            id: 'emailBodyInput',
            value: '',
        });
        const fileInput = new Input({
            label: 'Attachments to be added:',
            id: 'employeeDataAttachment',
            type: 'file'
        });
       

        // SEND button
        const sendBtn = button.build({
            id: 'employeeEmailSendBtn',
            text: 'Send',
            style: 'secondary',
            type: 'contained',
            callback: async () => {
                const toVal = document.getElementById('emailToInput')?.value.trim();                
                const ccVal = document.getElementById('emailCcInput')?.value || '';
                const bccVal = document.getElementById('emailBccInput')?.value || '';
                const subjectVal = document.getElementById('emailSubjectInput')?.value || `${entryData.category} - ${entryData.subCategory}` || '';                  

                if (!toVal) return;
                POPUP.hide(emailPopup);               
                const file = fileInput.input;
                let payload = {
                    toAddresses: toVal,
                    ccAddresses: ccVal,
                    bccAddresses: bccVal,
                    emailSubject: subjectVal,
                    emailBody: bodyContent || '',
                    attachmentType: '',
                    attachmentName:'',
                    attachment: ''
                };

                try {
                    if (file.files.length > 0) {
                        const attachmentFile = file.files.item(0);
                        payload.attachmentType = attachmentFile.name.split('.').pop();
                        payload.attachmentName = attachmentFile.name.split('.')[0];
                        const buffer = await attachmentFile.arrayBuffer();
                        const bytes = new Uint8Array(buffer);                       
                        payload.attachment = btoa(
                            Array.from(bytes, b => String.fromCharCode(b)).join('')
                        );
                    }
                   
                    await empDataAjax.sendEmailWithAttachmentAsync(payload);

                } catch (error) {
                    failSave.show('Failed to send email');
                    setTimeout(() => { failSave.hide(); }, 3000);
                    throw new Error(error.responseText);
                }         
                
            },
        });

        // Disable SEND initially if no email
        if (preSelectedEmail.trim() === '') {
            sendBtn.classList.add('disabled');
        } else {
            sendBtn.classList.remove('disabled');
        }

        const cancelBtn = button.build({
            id: 'employeeEmailCancelBtn',
            text: 'Cancel',
            style: 'secondary',
            type: 'outlined',
            callback: () => POPUP.hide(emailPopup),
        });

        const btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        btnWrap.appendChild(sendBtn);
        btnWrap.appendChild(cancelBtn);

        // Assemble the popup
        emailPopup.appendChild(heading);
        emailPopup.appendChild(selectEmployeeBtn);
        emailPopup.appendChild(toInput);
        emailPopup.appendChild(ccInput);
        emailPopup.appendChild(bccInput);
        emailPopup.appendChild(subjectInput);
        emailPopup.appendChild(bodyInput);
        emailPopup.appendChild(fileInput.rootElement);
        emailPopup.appendChild(btnWrap);

        document.body.appendChild(emailPopup);
        POPUP.show(emailPopup);

        if (typeof overlay !== 'undefined') {
            overlay.show();
        }
        document.getElementById('emailToInput').addEventListener('change', function () {
            toggleSendButton();
        });
        document.getElementById('emailBodyInput').addEventListener('change', function (e) {
            bodyContent = e.target.value;
        });
        var fileInputEle = fileInput.input;
        fileInputEle.addEventListener('input', e => {
            let isValid = fileValidation(e.target, emailPopup);
            toggleSendButton(isValid);
        });
        fileInputEle.addEventListener("keydown", function (e) {
            e.preventDefault();
        });
        function validateEmail(email) {
            const regex = /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})(\s*;\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,})*$/;
            return regex.test(email);
        }
        function toggleSendButton(isValidFile) {
            const toElem = document.getElementById('emailToInput');
            if (!toElem) return;
            const toVal = toElem.value.trim();
            if (!toVal || toVal === '') {
                sendBtn.classList.add('disabled');
                toElem.parentElement.classList.add('error');
            } else {
                if (isValidFile === undefined) {
                    isValidFile = true;
                }
                const isValidEmail = validateEmail(toVal);
                if (!isValidFile || !isValidEmail) sendBtn.classList.add('disabled');
                else sendBtn.classList.remove('disabled');
                if (!isValidEmail) {
                    toElem.parentElement.classList.add('error');
                }
                else {
                    toElem.parentElement.classList.remove('error');
                }
            }
        }
        toggleSendButton();
    }
    function fileValidation(target, emailPopup) {
        const fileType = target.files[0].type;
        const reFileTypeTest = new RegExp('(audio/)|(video/)');
        if (reFileTypeTest.test(fileType)) {
            POPUP.hide(emailPopup);
            failSave.show('Anywhere currently does not accept audio or video files');
            setTimeout(() => {
                failSave.hide();
                POPUP.show(emailPopup);
            }, 2000);
            target.value = '';
            return false;
        }
        const fileSize = target.files[0].size;
        const maxSize = 5 * 1024 * 1024; // 5 MB

        //check uploaded file size. If greater than 5MB, alert and clear input
        if (fileSize > maxSize) {
            POPUP.hide(emailPopup);
            failSave.show('The file size must be 5MB or smaller.  Please add a smaller file.');
            setTimeout(() => {
                failSave.hide();
                POPUP.show(emailPopup);
            }, 2000);
            target.value = '';
            return false;
        }
        return true;
    }
    function buildFilterPopup() {
        const widgetFilter = widget.querySelector('.widget__filters');
        if (widgetFilter) return;

        filterPopup = dashboard.buildFilterPopup();
        categoryDropdown = dropdown.build({
            dropdownId: 'employeeDataWidgetCategory',
            label: 'Category',
            style: 'secondary',
            readonly: false
        });
        sortByDropdown = dropdown.build({
            dropdownId: 'employeeDataWidgetSortBy',
            label: 'Sort By',
            style: 'secondary',
            readonly: false
        });
        expirationInput = input.build({
            id: 'employeeDataWidgetExpirationDays',
            label: 'Days Until Expiration (max:365)',
            type: 'number',
            max: 365,
            min: 0,
            value: selectedExpiration || '365'
        });
        applyFiltersBtn = button.build({
            text: 'Apply',
            style: 'secondary',
            type: 'contained',
            callback: async function (e) {
                widgetBody.innerHTML = '';
                filterPopup.classList.remove('visible');
                overlay.hide(); 
                PROGRESS__ANYWHERE.init();                     
                PROGRESS__ANYWHERE.SPINNER.show(widgetBody, "Loading");
                bodyScrollLock.enableBodyScroll(filterPopup);   
                
                selectedExpiration = selectedExpiration == '' ? '365' : selectedExpiration;
                const employeeDataWidgetExpirationDays = document.getElementById('employeeDataWidgetExpirationDays');
                employeeDataWidgetExpirationDays.value = selectedExpiration;

                widgetSettingsAjax.setWidgetFilter('dashEmployeeDatawidget', 'category', selectedCategory);
                widgetSettingsAjax.setWidgetFilter('dashEmployeeDatawidget', 'sortBy', selectedSortBy);
                widgetSettingsAjax.setWidgetFilter('dashEmployeeDatawidget', 'expirationDays', selectedExpiration);      
                
                await loadWidgetData(selectedCategory, selectedSortBy, selectedExpiration);
            }
        });
        cancelFilterBtn = button.build({
            text: 'Cancel',
            style: 'secondary',
            type: 'outlined',
            callback: function (e) {
                filterPopup.classList.remove('visible');
                overlay.hide();
                bodyScrollLock.enableBodyScroll(filterPopup);
            }
        });

        const btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        btnWrap.appendChild(applyFiltersBtn);
        btnWrap.appendChild(cancelFilterBtn);      

        filterPopup.appendChild(categoryDropdown);
        filterPopup.appendChild(sortByDropdown);
        filterPopup.appendChild(expirationInput);
        filterPopup.appendChild(btnWrap);

        widget.insertBefore(filterPopup, widgetBody);       
       
    }
    async function populateDropdowns() {
        categories = await empDataAjax.getEmployeeDataCategoriesAsync();
        dropdown.populate('employeeDataWidgetCategory', categories, selectedCategory);
        sortData = [
            { id: 1, value: 'CAT_SUBCAT', text: 'Category/Subcategory' },
            { id: 2, value: 'EXP_ASC', text: 'Expiration Date - Ascending' },
            { id: 3, value: 'EXP_DESC', text: 'Expiration Date - Descending' },
        ];

        dropdown.populate('employeeDataWidgetSortBy', sortData, selectedSortBy);
    }
    function displayFilteredBy(daysUntil) {
        let filteredBy = widget.querySelector('.widgetFilteredBy');

        if (!filteredBy) {
            filteredBy = document.createElement('div');
            filteredBy.classList.add('widgetFilteredBy');
            widgetBody.appendChild(filteredBy);
        }
        let sortOrder = sortData.find(item => item.value === selectedSortBy);
        let category = categories.find(item => item.value === selectedCategory);
        if (daysUntil !== '') {
            filteredBy.innerHTML =
                `<div class="filteredByData">
                <p><span>Category:</span> ${category?.text??'All'}</p>
                <p><span>Sort By:</span> ${sortOrder?.text??''}</p>
                <p><span>Expiration (days):</span> ${selectedExpiration ?? '365'}</p>
            </div>`;
        }
        else {
            filteredBy.innerHTML =
                `<div class="filteredByData">
                <p><span>Category:</span> ${category?.text ?? 'All'}</p>
                <p><span>Sort By:</span>  ${sortOrder?.text ?? ''}</p>              
            </div>`;
        }          
    }
    function setupEvents() {
        categoryDropdown.addEventListener('change', (e) => {
            selectedCategory = e.target.value;
        });

        sortByDropdown.addEventListener('change', (e) => {
            selectedSortBy = e.target.value;
        });

        expirationInput.addEventListener('input', (e) => {
            let value = parseInt(e.target.value,10);
            if (value < 0) e.target.value = 0;
            if (value > 365) e.target.value = 365;
            selectedExpiration = e.target.value;           
        });
       
    }
    async function loadWidgetData(categoryId, sortOrder, daysUntil) {    
     try {
        const result = await empDataAjax.getEmployeeDataWidgetAsync({
            token: $.session.Token,
            categoryId: categoryId,
            sortOrder: sortOrder,
            daysUntil: daysUntil
        });
        const tableData = result.map((row, idx) => {
            const isExpired = row.expiration_date
                && moment(row.expiration_date).isSameOrBefore(moment(), 'day');
            const expirationDateFormatted = row.expiration_date ? moment(row.expiration_date).format('MM/DD/YYYY') : '';  
            return {
                id: `row-${idx}`,
                values: [
                    row.empdatacat_name,
                    row.empdatasubcat_name,
                    expirationDateFormatted                
                ],
                attributes: isExpired
                    ? [{ key: 'class', value: 'table__row expiredRow' }]
                    : [],
                endIcon: icons.Email,
                endIconCallback: e => {
                    e.stopPropagation();
                    const entryData = {
                        id: idx,
                        category: row.empdatacat_name,
                        subCategory: row.empdatasubcat_name,
                        expirationDate: row.expiration_date,
                    };
                    showEmployeeEmailPopup(entryData);
                },
                
            };
        });        
        table.populate(tableElement, tableData); 
        displayFilteredBy(daysUntil); 
        widgetBody.appendChild(tableElement);      
      
        if (widgetBody) PROGRESS__ANYWHERE.SPINNER.hide(widgetBody, "Loading");

      } catch (error) {
         if (widgetBody) PROGRESS__ANYWHERE.SPINNER.hide(widgetBody, "Loading");
         throw new Error(error.responseText);
      }
    }
    async function init() {
        PROGRESS__ANYWHERE.init();
        widget = document.getElementById('employeeDataWidget');
        widgetBody = widget.querySelector('.widget__body');     
        dashboard.appendFilterButton('employeeDataWidget', 'employeeDataFilterBtn');
        const tableOptions = {
            plain: true,
            columnHeadings: ['Category', 'Subcategory', 'Expiration Date'],
            tableId: 'employeeDataWidgetTable',
            endIcon: true,
        };
        tableElement = table.build(tableOptions);
        const headers = tableElement.querySelectorAll('.header div');
        headers[0].setAttribute('data-type', 'string');
        headers[1].setAttribute('data-type', 'string');
        headers[2].setAttribute('data-type', 'date');       
        table.sortTableByHeader(tableElement);     
        PROGRESS__ANYWHERE.SPINNER.show(widgetBody, "Loading");
       
        const catFilter = await widgetSettingsAjax.getWidgetFilter('dashEmployeeDatawidget', 'category');
        selectedCategory = catFilter?.getWidgetFilterResult || 'ALL';
        const sortFilter = await widgetSettingsAjax.getWidgetFilter('dashEmployeeDatawidget', 'sortBy');
        selectedSortBy = sortFilter?.getWidgetFilterResult || 'CAT_SUBCAT';
        const expFilter = await widgetSettingsAjax.getWidgetFilter('dashEmployeeDatawidget', 'expirationDays');
        selectedExpiration = expFilter?.getWidgetFilterResult || '365';

        buildFilterPopup();
        await populateDropdowns();
        setupEvents();       
        await loadWidgetData(selectedCategory, selectedSortBy, selectedExpiration);        
    }
    return {
        init
    }
})();
